const mapEndpoints = {
  APPOINTMENTS: "appointments",
  MARKER: "marker",
};

export default mapEndpoints;
